var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.position !== null)?_c('rect',{staticClass:"canvas-cursor",class:{
    'thick': _vm.byMeasure,
    'focus': _vm.focusCursor
  },attrs:{"tabindex":"-1","x":_vm.position.x - 2,"y":_vm.y,"width":_vm.width,"height":_vm.height}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }